import { getMentionBadgeClasses } from '../../components/mention-badge/mention-badge-styles';
import type { AtMentionOption } from '../../types';
import { attachMentionBadgeHandler } from '../attachMentionBadgeHandlers';

const createAtMentionBadge = (
  spanElement: HTMLSpanElement,
  option?: AtMentionOption,
): HTMLElement => {
  const badgeClasses = getMentionBadgeClasses();
  const label = option?.label ?? 'Answer to question was moved or deleted';

  const badge = document.createElement('span');
  badge.contentEditable = 'false';
  badge.className = `mention-badge ${badgeClasses.badge} ${option ? '' : badgeClasses.invalid}`;
  badge.setAttribute('data-mention-label', label);
  badge.setAttribute('data-mention-value', option?.value ?? 'invalid-recall-question-id');
  if (!option) {
    badge.setAttribute('data-mention-invalid', 'true');
  }
  badge.textContent = label;

  // Create close button
  const closeBtn = document.createElement('span');
  closeBtn.setAttribute('data-badge-close-button', 'true');
  closeBtn.contentEditable = 'false';
  closeBtn.className = badgeClasses.closeButton;
  closeBtn.textContent = '×';

  badge.appendChild(closeBtn);

  if (spanElement) {
    attachMentionBadgeHandler(closeBtn, badge, spanElement);
  }

  return badge;
};

export default createAtMentionBadge;
